import Events from '@utilities/events'

const LAP_ACTIVE = 'form__item--lap-active'
const INPUT_QUERY = 'input, textarea, select'

class LabelAsPlaceholder {
  constructor(element) {
    this.formItem = element
    this.input = this.formItem.querySelector(INPUT_QUERY)

    if (this.formItem) {
      this.toggleLabelClass()
      this.bindEvents()
    }
  }

  bindEvents() {
    this.input.addEventListener('change', () => this.toggleLabelClass())

    Events.$on(`lap[${this.input.id}]::toggle-update`, () => this.toggleLabelClass())

    if (this.input.type !== 'file') {
      this.input.addEventListener('input', () => this.toggleLabelClass(true))
      this.input.addEventListener('focus', () => this.toggleLabelClass(true))
      this.input.addEventListener('focusout', () => this.toggleLabelClass())
      this.input.addEventListener('change', () => this.toggleLabelClass())
    }
  }

  toggleLabelClass(forceAnimateLabel) {
    const action = forceAnimateLabel || this.input.value ? 'add' : 'remove'

    this.formItem.classList[action](LAP_ACTIVE)
  }
}

export default LabelAsPlaceholder
